export const ApiEndpoints = {
	welcome: '/users',
	login: '/login',
	register: '/register',
	profile: '/profile',
	resetPassword: '/reset-password',
	billing: '/billing-and-shipping',
	getAllKids: '/kids',
	addKid: 'add-child',
	removeKid: '/remove-child',
	updateKid: '/update-kids',
	milestoneCategories: '/developmentCategories',
	milestonesListByCategory: '/milestones',
	saveMilestone: '/milestoneAchieved',
	ageGroup: '/ageGroup',
	resourceCategory: '/resourceCategory',
	resourceById: '/resources',
	getAllExercises: '/exercises',
	subscribe: '/subscribe',
	cancelSubscription: '/subscription',
	getToy: '/toy',
	questionarre: '/questionarre',
	activateWelcome: '/updateWelcome',
	forgotPassword: '/forgot-password',
	milestoneDetails: '/milestone',
	newPassword: '/newPassword',
	questions: '/questions',
	generateNewToy: '/generate-toy',
	exerciseDetails: '/exercise',
	exerciseCategories: '/exercisesCategory',
	activateEmail: '/verify',
	upgrade: '/upgrade',
	giftMembership: '/checkValidity',
	activategiftMembership: '/activateWithGiftCard',
	addUserEndpoint: '/registerWithGiftCard',
	logout: '/logout',

	lookupKid: '/kids',
	userToys: 'user-toys',
	ship: '/ship',
	nextToy: '/roll-over-new-toy',
	changeDate: '/change-date',
	kidAddress: '/kids-address',
};
